// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

let _yccApiUrl: string = '';
let _azureAuthUrl: string = '';
let _logoutUrl: string = '';
let _appid = '67';
let _isDebugMode = false;
let _awshelperApiUrl: string = '';
let _yccDataBucket: string = '';
let _yccLogoFolder: string = '';
let _yccDocumentFolder: string = '';
let _s3Region: string = '';


//localhost
  // _yccApiUrl =    'http://localhost:28555/api/';// 'https://4cn1mzsteh.execute-api.us-west-1.amazonaws.com/dev/api/' ; //'https://api-comm-dev.sacramentoda.org/ycc/api/'; //
  // _azureAuthUrl = 'https://api-dev.sacramentoda.org/azureauth/authenticate';
  // _logoutUrl = "https://login.microsoftonline.com/753495fb-15a7-4e05-ad08-63e263e16524/oauth2/logout?post_logout_redirect_uri=https://childabduction-dev.sacda.org/logout"
  // _isDebugMode = true;
  // _awshelperApiUrl = 'https://api-comm-dev.sacramentoda.org/aws/api/'; //'https://yixb1w5mvi.execute-api.us-west-1.amazonaws.com/dev/api/';//
  // _yccDataBucket = 'ycc-files-dev';

//Development
  // _yccApiUrl =   'https://api-comm-dev.sacramentoda.org/ycc/api/'; //// 'http://localhost:28555/api/';// 'https://4cn1mzsteh.execute-api.us-west-1.amazonaws.com/dev/api/' ; //'https://api-comm-dev.sacramentoda.org/ycc/api/'; //
  // _azureAuthUrl = 'https://api-dev.sacramentoda.org/azureauth/authenticate';
  // _logoutUrl = "https://login.microsoftonline.com/753495fb-15a7-4e05-ad08-63e263e16524/oauth2/logout?post_logout_redirect_uri=https://childabduction-dev.sacda.org/logout"
  // _isDebugMode = false;
  // _awshelperApiUrl = 'https://api-comm-dev.sacramentoda.org/aws/api/'; //'https://yixb1w5mvi.execute-api.us-west-1.amazonaws.com/dev/api/';//
  // _yccDataBucket = 'ycc-files-dev';


  //QA
  // _yccApiUrl =  'https://api-comm-qa.sacramentoda.org/ycc/api/'; //'https://api-comm-qa.sacramentoda.org/ycc/api/'; //'https://4cn1mzsteh.execute-api.us-west-1.amazonaws.com/dev/api/';// 
  // _azureAuthUrl = 'https://api-qa.sacramentoda.org/azureauth/authenticate';
  // _logoutUrl = "https://login.microsoftonline.com/753495fb-15a7-4e05-ad08-63e263e16524/oauth2/logout?post_logout_redirect_uri=https://childabduction-dev.sacda.org/logout"
  // _isDebugMode = false;
  // _awshelperApiUrl = 'https://api-comm-qa.sacramentoda.org/aws/api/'; // https://api-comm-qa.sacramentoda.org/aws/api/';
  // _yccDataBucket = 'ycc-files-qa';


  //PD
   _yccApiUrl =  'https://api-comm-pd.sacramentoda.org/ycc/api/' ; //'https://api-comm-pd.sacramentoda.org/ycc/api/'; //'https://4cn1mzsteh.execute-api.us-west-1.amazonaws.com/dev/api/';// 
  _azureAuthUrl = 'https://api.sacramentoda.org/azureauth/authenticate';
  _logoutUrl = "https://login.microsoftonline.com/753495fb-15a7-4e05-ad08-63e263e16524/oauth2/logout?post_logout_redirect_uri=https://childabduction-dev.sacda.org/logout"
  _isDebugMode = false;
  _awshelperApiUrl =  'https://api-comm-pd.sacramentoda.org/aws/api/'; //'https://api-comm-pd.sacramentoda.org/aws/api/';
  _yccDataBucket = 'ycc-files';


  _yccLogoFolder = 'Logos/';
  _yccDocumentFolder = 'Documents/';
  _s3Region = 'us-west-1';

export const yccApiUrl = _yccApiUrl;
export const AzureAuthUrl = _azureAuthUrl;
export const AppId = _appid;
export const LogoutUrl = _logoutUrl;
export const IsDebugMode = _isDebugMode;
export const AwshelperApiUrl = _awshelperApiUrl;
export const YccDataBucket = _yccDataBucket;
export const YccLogoFolder = _yccLogoFolder;
export const YccDocumentFolder = _yccDocumentFolder;
export const S3Region = _s3Region;